const productInfo = document.querySelector('product-info .pricestyle');
const moneyModule = document.querySelector('money-conversion');
const colonDayValue = parseInt(moneyModule.getAttribute('data-col'));
const colonPrice = moneyModule.querySelector('.full-price');
const nmpColonPrice = moneyModule.querySelector('.nmp-24-price');

function watchInfo() {
  if (!productInfo) {
    console.warn('No se encontró <product-info>');
    return;
  }

  const actualizarPrecio = () => {
    const textPrice = document.querySelector('product-info .actual_price span');
    const colonDayValue = parseInt(moneyModule.getAttribute('data-col'));
    const fullPrice =
      colonDayValue *
      parseInt(
        textPrice.textContent
          .replace('USD', '')
          .replace('$', '')
          .replaceAll(',', '')
          .replaceAll('.', '')
          .trim() / 100,
      );
    const nmpPrice = fullPrice / 24;

    colonPrice.textContent = setFormat(fullPrice);
    nmpColonPrice.textContent = `${setFormat(nmpPrice)}/ mes por 24 meses`;

    if (textPrice) {
      console.log('Precio actualizado:', fullPrice);
    }
  };

  const observer = new MutationObserver(() => {
    actualizarPrecio();
  });

  observer.observe(productInfo, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  return observer;
}

function setFormat(num) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(num)
    .replace('CRC', '₡')
}

watchInfo();